import { Route } from "@angular/router";

import { NotArchivedPlan } from "../../../core/guards";
import { manageBenchmarkDataEntryGuards, viewBenchmarkDataEntryGuards } from "../_guards";

export const BENCHMARK_ACTUALS_ROUTES: Route[] = [
  {
    path: "benchmark",
    canActivate: [...viewBenchmarkDataEntryGuards],
    children: [
      {
        path: "",
        data: {
          title: "data_entry.benchmark_actuals",
          breadcrumb: "data_entry.benchmark_actuals",
        },
        loadComponent: () =>
          import("./benchmark-actuals-list/benchmark-actuals-list").then((e) => e.BenchmarkActualsListComponent),
      },
      {
        path: "edit/:id",
        canActivate: [NotArchivedPlan(), ...manageBenchmarkDataEntryGuards],
        data: {
          title: "data_entry.edit_title",
          breadcrumb: "data_entry.edit_title",
        },
        loadComponent: () =>
          import("./benchmark-actuals-editor/benchmark-actuals-editor").then((e) => e.BenchmarkActualsEditorComponent),
      },
    ],
  },
];
